import { render, staticRenderFns } from "./Registernew.vue?vue&type=template&id=65dc15e2&scoped=true"
import script from "./Registernew.vue?vue&type=script&lang=js"
export * from "./Registernew.vue?vue&type=script&lang=js"
import style0 from "../assets/login.css?vue&type=style&index=0&id=65dc15e2&prod&scoped=true&lang=css&external"
import style1 from "./Registernew.vue?vue&type=style&index=1&id=65dc15e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dc15e2",
  null
  
)

export default component.exports